import { Controller } from "@hotwired/stimulus";
import * as React from "react";
import type { Root } from "react-dom/client";
import reactRenderer from "~/lib/reactRenderer";
import QRCode from "qrcode.react";

export default class extends Controller {
  static values = {
    value: String,
    size: { type: Number, default: 260 },
    level: { type: String, default: "H" },
  };

  declare valueValue: string;
  declare sizeValue: number;
  declare levelValue: string;

  private root: Root | undefined;

  connect() {
    this.renderQRCode();
  }

  disconnect() {
    this.root?.unmount();
  }

  renderQRCode() {
    this.root = reactRenderer(
      React.createElement(QRCode, {
        renderAs: "svg",
        fgColor: "currentColor",
        bgColor: "transparent",
        width: this.sizeValue,
        height: this.sizeValue,
        level: this.levelValue,
        style: { maxWidth: "100%" },
        value: this.valueValue,
      }),
      this.element as Element,
      this.root,
    );
  }
}
